import { Get_All_Users_Devices, Get_Error, logout_session_One_Device_Type } from '../Types';

const intial = {
  User_Devices: [],

  loading: true,
};

const Devices_reducers = (state = intial, action) => {
  switch (action.type) {
    case Get_All_Users_Devices:
      return {
        User_Devices: action.payload,
        loading: false,
      };
    case logout_session_One_Device_Type:
      return {
        User_Devices: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Developers: action.payload,
      };
    default:
      return state;
  }
};

export default Devices_reducers;
